import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './config/axios'; // Initialize axios interceptors

// ============================================================================
// SERVICE WORKER KILL-SWITCH (AGGRESSIVE - RUNS BEFORE REACT)
// Eliminates any legacy service workers that may be routing to old backends
// ============================================================================
(async function killServiceWorkers() {
  // Log the API base URL being used (for debugging)
  const apiBaseUrl = process.env.REACT_APP_BACKEND_URL || '';
  console.log('[MCM BOOT] API Base URL:', apiBaseUrl || '(same-origin - relative paths)');
  console.log('[MCM BOOT] Current origin:', window.location.origin);
  
  if ('serviceWorker' in navigator) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      if (registrations.length > 0) {
        console.log('[SW KILL] Found', registrations.length, 'service worker(s). Eliminating...');
        
        // Unregister all service workers
        await Promise.all(registrations.map(async (reg) => {
          console.log('[SW KILL] Unregistering:', reg.scope);
          await reg.unregister();
        }));
        
        console.log('[SW KILL] All service workers unregistered');
      }
    } catch (e) {
      console.error('[SW KILL] Error unregistering service workers:', e);
    }
  }
  
  // Clear ALL caches regardless of service worker state
  if ('caches' in window) {
    try {
      const cacheNames = await caches.keys();
      if (cacheNames.length > 0) {
        console.log('[CACHE KILL] Found', cacheNames.length, 'cache(s). Deleting...');
        await Promise.all(cacheNames.map(async (name) => {
          console.log('[CACHE KILL] Deleting cache:', name);
          await caches.delete(name);
        }));
        console.log('[CACHE KILL] All caches deleted');
      }
    } catch (e) {
      console.error('[CACHE KILL] Error clearing caches:', e);
    }
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);